import axios from 'axios';
import { stringify } from 'qs';
import { snakeCase, cloneDeep } from 'lodash';
import { ApiService } from '../api/api.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { FiltersService } from '../filters/filters.service';
import { env } from '../env/env';
import { toSnakeCase, toCamelCase } from './helpers';
export var ContentTypeHeaders;
(function (ContentTypeHeaders) {
    ContentTypeHeaders["DATA_FILE"] = "multipart/form-data";
})(ContentTypeHeaders || (ContentTypeHeaders = {}));
const port = env('REACT_APP_PORT');
export const PROTOCOL = port === 443 || env('REACT_APP_FORCE_SSL') === true ? 'https' : 'http';
export const PCS_URL = `${PROTOCOL}://app.${env('REACT_APP_DOMAIN')}${port !== 80 && port !== 443 ? `:${port}` : ''}/`;
export const LANDING_URL = `${PROTOCOL}://${env('REACT_APP_DOMAIN')}/`;
export const API_URL = `${PCS_URL}api/`;
const API_VERSION = 'v1';
export class PcsApiService {
    constructor(config = {}, interceptors, _authService = new AuthenticationService(), _filterService = new FiltersService()) {
        this._authService = _authService;
        this._filterService = _filterService;
        const { headers, apiVersion = API_VERSION, transformParamsFilter, transformRequestFilter, transformResponseFilter, ...other } = config;
        const pcsApiConfig = {
            timeout: 30000,
            ...other,
            baseURL: `${API_URL}${apiVersion || ''}`,
            headers: {
                ...headers
            },
            transformResponse: [
                ...(Array.isArray(axios.defaults.transformResponse)
                    ? axios.defaults.transformResponse
                    : axios.defaults.transformResponse
                        ? [axios.defaults.transformResponse]
                        : []),
                (data) => {
                    let response = data;
                    if (typeof data === 'object' && !(data instanceof ArrayBuffer)) {
                        response = toCamelCase(data, transformResponseFilter);
                    }
                    if (response.meta &&
                        response.meta.total &&
                        response.meta.total &&
                        !response.meta.totalPages) {
                        response.meta.totalPages = Math.ceil(response.meta.total / response.meta.perPage);
                    }
                    if (response.meta && response.meta.page !== undefined) {
                        response.meta.page = response.meta.page + 1;
                    }
                    return response;
                }
            ],
            paramsSerializer: (params) => {
                const paramsCopy = cloneDeep(params);
                if (paramsCopy.sortBy) {
                    paramsCopy.sortBy = snakeCase(paramsCopy.sortBy);
                }
                if (paramsCopy['q'] && apiVersion === 'v2') {
                    paramsCopy['q'] = this._filterService.mapFiltersForQuery(paramsCopy['q']);
                }
                const snakedParams = toSnakeCase(paramsCopy, transformParamsFilter);
                return stringify(snakedParams, { arrayFormat: 'brackets' });
            },
            transformRequest: [
                (data, headers) => {
                    headers['X-Spree-Token'] = this._authService.getToken();
                    return data;
                },
                (data, headers) => {
                    return headers['Content-Type'] === ContentTypeHeaders.DATA_FILE
                        ? data
                        : toSnakeCase(data, transformRequestFilter);
                },
                ...(Array.isArray(axios.defaults.transformRequest)
                    ? axios.defaults.transformRequest
                    : axios.defaults.transformRequest
                        ? [axios.defaults.transformRequest]
                        : [])
            ]
        };
        const combinedInterceptors = this.setInterceptors(interceptors);
        return new ApiService(pcsApiConfig, combinedInterceptors);
    }
    setInterceptors(interceptors) {
        interceptors = interceptors || {};
        interceptors.response = interceptors.response || {};
        interceptors.request = interceptors.request || {};
        const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
        if (isBrowser) {
            const passedErrorInterceptor = interceptors.response.error ||
                (() => {
                    return;
                });
            interceptors.response.error = (error) => {
                passedErrorInterceptor(error);
                if (error.code === '401')
                    window.location.href = '/';
            };
        }
        return interceptors;
    }
}
//# sourceMappingURL=pcs-api.service.js.map